import { Relics } from "../../Relics";

interface RelicsFormatterProps {
  value: number | null | undefined;
}

export const RelicsFormatter = ({ value }: RelicsFormatterProps) => (
  <Relics fullWidth value={value} />
);
